import * as Yup from 'yup';

// The lengths are the API's limits.
const signUpValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required('This field is required')
    .max(50, 'Use 50 characters or fewer'),
  email: Yup.string().email('Enter a valid email').required('This field is required'),
  phone: Yup.string().optional().max(25, 'Use 25 characters or fewer'),
  captchaToken: Yup.string().optional(),
});

export const signupResolver = async (data) => {
  try {
    const values = await signUpValidationSchema.validate(data, {
      abortEarly: false,
    });

    return {
      values,
      errors: {},
    };
  } catch (errors) {
    return {
      values: {},
      errors: errors.inner.reduce(
        (allErrors, currentError) => ({
          ...allErrors,
          [currentError.path]: {
            type: currentError.type ?? 'validation',
            message: currentError.message,
          },
        }),
        {},
      ),
    };
  }
};
